import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import EndorsementOptionSection from './EndorsementOptionSection';
import Navigator from '../../../Navigation/Navigator';
import M from 'materialize-css';
import ApplicationsAction, {
   isSaveApplicationSuccess,
   isSaveApplicationFailure,
   isSavingApplication,
   saveApplicationRequest
} from 'pgdb-data-layer/lib/Redux/ApplicationsRedux';
import { connect } from 'react-redux';
import { getToken } from '../../../Session/SessionRedux';
import { APPLICATION_ENDORSEMENT, ENDORSEMENT_TYPE_PLUMBER, ENDORSEMENT_TYPE_DRAINLAYER, APPLICATION_ENDORSEMENT_RENEWAL } from 'pgdb-data-layer/lib/Helpers/Endorsement';

const EndorsementSelectionStep = ({
   selectedEndorsements,
   setSelectedEndorsements,
   eligibility,
   token,
   isDisabled,
   onNext,
   userContactData,
   endorsements,
   saveApplicationRequest,
   isSaveApplicationSuccess,
   isSaveApplicationFailure,
   applicationsCreated,
   isEditMode,
   applicationId,
   isRenewal,
}) => {
   const hasHandledSuccess = useRef(false);

   const isActiveEndorsement = (endorsementTypeCode) => {
      return endorsements.some(e => e.endorsementTypeCode === endorsementTypeCode);
   }

   const saveAndAction = (goingNext) => {
      if (!isEditMode) {
         // Save application
         const selected = [];
         if (selectedEndorsements.plumber) selected.push(ENDORSEMENT_TYPE_PLUMBER);
         if (selectedEndorsements.drainlayer) selected.push(ENDORSEMENT_TYPE_DRAINLAYER);

         if (selected.length === 0) {
            M.toast({html: 'Please select at least one endorsement type.', classes: 'error'});
            return;
         }

         // Prepare payload for endorsement application
         const payload = {
            applications: [],
         };

         payload.applications.push({
            contactId: userContactData.contactId,
            applicationTypeCode: isRenewal ? APPLICATION_ENDORSEMENT_RENEWAL : APPLICATION_ENDORSEMENT,
            licenseYearId: 0,
            createLicence: false,
            isRegistrationApplication: false,
            endorsementTypeCodes: selected,
         });
         saveApplicationRequest(token, payload);
         //logic to move next or back on the success callback of save application request 
   
      } else { 
         // Edit mode 
         onNext(applicationId);
      }
      if (!goingNext) {
         Navigator.toEndorsements();
      }
   };

   React.useEffect(() => {
      if (isSaveApplicationSuccess && !hasHandledSuccess.current && applicationsCreated && applicationsCreated.length > 0) {
         hasHandledSuccess.current = true;
         M.toast({html: 'Endorsement application saved successfully.', classes: 'success'});
      }
      if (isSaveApplicationFailure) {
         hasHandledSuccess.current = false;
         M.toast({html: 'Failed to save endorsement application. Please try again.', classes: 'error'});
      }
   }, [isSaveApplicationSuccess, isSaveApplicationFailure]);

   return (
      <div className="section no-pad-bot" id="index-banner">
         <div className="container registration-container">
            <div className="row no-margin flex">
               <div className="col l9 m8 s12">
                  <div className="col m8 offset-l1 s12">
                     <h6 className="subheader">
                        Endorsement type
                     </h6>
                  </div>
                  <div className="col m8 offset-l1 s12">
                     <p className="grey2-text medium-text medium-font">
                        Select the type of Self-Certification Endorsement you want to {isRenewal ? 'renew' : 'apply'} for:
                     </p>
                  </div>
                  <div className="col m12 l9 offset-l1 s11">
                     <EndorsementOptionSection
                        heading={"Plumbing" + (isRenewal
                           ? (!eligibility.hasPlumber ? " (Not eligible)" : eligibility.isRenewingPlumber ? " (Renewal)" : "")
                           : (isActiveEndorsement(ENDORSEMENT_TYPE_PLUMBER) ? " (Active)" : !eligibility.hasPlumber ? " (Not eligible)" : "")
                        )}
                        endorsementCode={ENDORSEMENT_TYPE_PLUMBER}
                        disabled={!eligibility.hasPlumber}
                        selectedValue={selectedEndorsements.plumber}
                        onSelect={value =>
                           setSelectedEndorsements(prev => ({
                              ...prev,
                              plumber: value,
                           }))
                        }
                     />

                     <EndorsementOptionSection
                        heading={"Drainlaying" + (isRenewal
                           ? (!eligibility.hasDrainlayer ? " (Not eligible)" : eligibility.isRenewingDrainlayer ? " (Renewal)" : "")
                           : (isActiveEndorsement(ENDORSEMENT_TYPE_DRAINLAYER) ? " (Active)" : !eligibility.hasDrainlayer ? " (Not eligible)" : "")
                        )}
                        endorsementCode={ENDORSEMENT_TYPE_DRAINLAYER}
                        disabled={!eligibility.hasDrainlayer}
                        selectedValue={selectedEndorsements.drainlayer}
                        onSelect={value =>
                           setSelectedEndorsements(prev => ({
                              ...prev,
                              drainlayer: value,
                           }))
                        }
                     />
                     <div className="row registration-type-profile-row next-button-registration right">
                        <div className="navigate-buttons">
                           <button
                              type="button"
                              className="waves-light btn btn-inactive"
                              onClick={() => saveAndAction(false)}
                              disabled={isDisabled}
                           >
                              Save and Exit
                           </button>
                           <button
                              type="button"
                              className="waves-effect waves-light btn btn-ml-30"
                              onClick={() => saveAndAction(true)}
                              disabled={isDisabled}
                           >
                              Next
                           </button>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   );
};

EndorsementSelectionStep.propTypes = {
   selectedEndorsements: PropTypes.object.isRequired,
   setSelectedEndorsements: PropTypes.func.isRequired,
   eligibility: PropTypes.object.isRequired,
   isDisabled: PropTypes.bool.isRequired,
   onNext: PropTypes.func.isRequired,
   onExit: PropTypes.func,
   endorsements: PropTypes.array,
   userContactData: PropTypes.object,
   isEditMode: PropTypes.bool,
   applicationId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
   isRenewal: PropTypes.bool,
};

const mapDispatchToProps = {
   saveApplicationRequest: ApplicationsAction.saveApplicationRequest,
};

const mapStateToProps = state => {
   return {
      token: getToken(state),
      userContactData: state.user.contactData,
      isSaveApplicationSuccess: isSaveApplicationSuccess(
         'saveApplication',
         state
      ),
      isSaveApplicationFailure: isSaveApplicationFailure(
         'saveApplication',
         state
      ),
      isSavingApplicationBusy: isSavingApplication('saveApplication', state),
      applicationsCreated: state.application.payload.applications,
   };
};

export default connect(mapStateToProps, mapDispatchToProps)(EndorsementSelectionStep);